
import { editPassword } from '@/api'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { Device } from '@/store/types'
import { EventBuss } from '@/utils/constants'
import { UserInfo } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Action, Getter } from 'vuex-class'

@Options({})
export default class ChangePassView extends Vue {
    iN = useI18n().t
    errorMessage = ''
    oldPass = ''
    newPass = ''
    confirmPass = ''

    isMobile = false
    $emit!: Vue['emit']
    emitter!: Vue['emitter']

    //#region Store Getter
    @Getter('userId') uid!: string
    @Getter('device') device!: Device
    @Getter('memberId') memberId!: number
    @Getter('token') token!: string
    @Getter('userInfo') userInfo!: UserInfo
    //#endregion

    //#region Store Action
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    //#endregion
    //#region Vue Methods
    beforeMount(): void {
        this.isMobile = this.device.display === 1
    }
    //#endregion

    OnClickClose(): void {
        this.$emit('on-close')
    }
    OnCLickConfirm(): void {
        if (this.oldPass === '') {
            // this.errorMessage = '请输入旧密码的值'
            this.errorMessage = '原密码错误或新密码不一致'
            return
        }

        if (this.newPass === '') {
            // this.errorMessage = '请输入密码值'
            this.errorMessage = '原密码错误或新密码不一致'
            return
        }

        if (this.newPass !== this.confirmPass) {
            // this.errorMessage = '密码不匹配'
            this.errorMessage = '原密码错误或新密码不一致'
            return
        }

        this.showLoading()

        const _params = {
            memberId: this.memberId,
            oldPassword: this.oldPass,
            newPassword: this.newPass,
            newPassword2: this.confirmPass,
            token: this.token
        }

        editPassword(_params)
            .then(r => {
                this.hideLoading()
                const response = r.data
                if (response.status === 200) {
                    this.emitter.emit(EventBuss.TOAST_MESSAGE, '修改成功')
                    const _copy = { ...this.userInfo }
                    _copy.firstLogin = 1
                    store.commit(UserMutation.SET_USER_INFO, _copy)
                    this.OnClickClose()
                } else {
                    this.errorMessage = response.description
                }
            })
            .catch(e => {
                this.showLoading
                this.errorMessage = '无法连接到服务器'
                this.hideLoading()
            })
    }
}
